__turbopack_context__.v({
  "content": "_1wQLna_content",
  "contentShell": "_1wQLna_contentShell",
  "footer": "_1wQLna_footer",
  "root": "_1wQLna_root",
  "splineContainer": "_1wQLna_splineContainer",
});
